import { ErrorBoundary } from '@capturi/react-utils'
import React from 'react'
import { Route, Routes } from 'react-router'

import { getRoutes } from './routes'
import SentimentPage from './sentiment'
import Loader from './shared/components/Loader'
import { TimeResolutionProvider } from './shared/contexts/ResolutionContext'

const pageRoutes = getRoutes(false)

const Analytics: React.FC = () => {
  return (
    <TimeResolutionProvider>
      <ErrorBoundary>
        <React.Suspense fallback={Loader}>
          <Routes>
            <Route path="/">
              <Route path={pageRoutes.sentiment} element={<SentimentPage />} />
            </Route>
          </Routes>
        </React.Suspense>
      </ErrorBoundary>
    </TimeResolutionProvider>
  )
}

export default Analytics
